<template>
  <router-link
    v-if="to.startsWith('/')"
    :to="to"
    class="button large"
    :class="classes"
  >
    <span class="button-label">
      <slot></slot>
    </span>
    <span
      v-if="arrow === 'right'"
      class="button-arrow button-arrow_right"
    >
      <ArrowheadRight />
    </span>
    <span
      v-else-if="arrow === 'down'"
      class="button-arrow button-arrow_down"
    >
      <ArrowDown />
    </span>
  </router-link>
  <a
    v-else
    :href="to"
    :target="target"
    :download="download"
    class="button large"
    :class="classes"
  >
    <span class="button-label">
      <slot></slot>
    </span>
    <span
      v-if="arrow === 'right'"
      class="button-arrow button-arrow_right"
    >
      <ArrowheadRight />
    </span>
    <span
      v-else-if="arrow === 'down'"
      class="button-arrow button-arrow_down"
    >
      <ArrowDown />
    </span>
  </a>
</template>

<script>
import ArrowheadRight from '@/assets/icons/icon-arrowhead-right.svg';
import ArrowDown from '@/assets/icons/icon-arrow-down.svg';

export default {
  name: 'Button',
  components: {
    ArrowDown,
    ArrowheadRight,
  },
  props: {
    to: {
      type: String,
      default: 'javascript:void(0)',
    },
    target: String,
    download: String,
    hollow: Boolean,
    arrow: {
      validator: (value) => (
        [null, 'right', 'down'].includes(value)
      )
    },
  },
  computed: {
    classes () {
      return {
        hollow: this.hollow,
        arrowed: this.arrow !== null,
        'arrowed-right': this.arrow === 'right',
        'arrowed-down': this.arrow === 'down',
      };
    },
  },
};
</script>
